export const EXERCISE_TYPE = {
  INTELLIGENT: '1',
  FAVORITES: '2',
  CORRECTING: '3',
  SEQUENTIAL: '4',
  CHAPTER: '5',
  SPECIFIC: '6',
};
export const EXERCISE_TITLE = [
  '智能练习',
  '题目收藏',
  '错题本',
  '顺序练习',
  '随机练习',
  '专项练习',
  '顺序练习(大题)',
  '题库练习',
];
export const GET_QUESTION_LIST_SUCCESS = 'GET_QUESTION_LIST_SUCCESS';
export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
export const UPDATE_QUESTION_HTML_SUCCESS = 'UPDATE_QUESTION_HTML_SUCCESS';
export const SAVE_QUESTION_RANGY_MARK = 'SAVE_QUESTION_RANGY_MARK';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const ANSWER_SUCCESS = 'ANSWER_SUCCESS';
export const QUESTION_SUBMITTED_SUCCESS = 'QUESTION_SUBMITTED_SUCCESS';
export const SET_QUESTION = 'SET_QUESTION';
export const GET_FILTER_LIST_SUCCESS = 'GET_FILTER_LIST_SUCCESS';
export const GET_MY_FAVORITE_TYPE_QUESTION_LIST_SUCCESS = 'GET_MY_FAVORITE_TYPE_QUESTION_LIST_SUCCESS';
export const GET_MY_WRONG_COUNT_LIST_SUCCESS = 'GET_MY_WRONG_COUNT_LIST_SUCCESS';
export const MARK_QUESTION_SUCCESS = 'MARK_QUESTION_SUCCESS';
export const GET_COURSE_ANALYSIS_SUCCESS = 'GET_COURSE_ANALYSIS_SUCCESS';
export const GET_FIRST_FILTER_LIST_SUCCESS = 'GET_FIRST_FILTER_LIST_SUCCESS';
export const GET_PZ_FILTER_DATA_SUCCESS = 'GET_PZ_FILTER_DATA_SUCCESS';
export const GET_AFTER_EXERCISE_SUCCESS = 'GET_AFTER_EXERCISE_SUCCESS';
export const SET_BOOK_LEVEL_UP_TO = 'SET_BOOK_LEVEL_UP_TO';
export const SET_COURSE_LEVEL_UP_TO = 'SET_COURSE_LEVEL_UP_TO';
export const SET_BOOK_LEVEL_UP_STATUS = 'SET_BOOK_LEVEL_UP_STATUS';
export const SET_COURSE_LEVEL_UP_STATUS = 'SET_COURSE_LEVEL_UP_STATUS';
export const REMOVE_WRONG_LIST_SUCCESS = 'REMOVE_WRONG_LIST_SUCCESS';
export const NOTE_SAVED_SUCCESS = 'NOTE_SAVED_SUCCESS';
